import dayjs from 'dayjs';

// Travel date validation compares against the browser's own date, so a report of a
// failed validation is only actionable next to the timezone the browser was in.
const getBrowserDateContext = () => ({
  browserTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  browserUtcOffsetMinutes: -new Date().getTimezoneOffset(),
  browserToday: dayjs().format('YYYY-MM-DD'),
});

export default getBrowserDateContext;
